import { useHistory } from "react-router-dom";
import { Button, Dropdown } from "react-bootstrap";
import { FaEye } from "react-icons/fa";

const VehiclesTable = ({ vehicles, onEdit, onDelete, isDeleting }) => {
  const history = useHistory();

  const handleViewPackages = (vehicleId, vehicleName) => {
    history.push(`/fleet-management/vehicles/${vehicleId}/packages`, { vehicleName });
  };
  return (
    <div className="table-responsive">
      <table className="table table-striped">
        <thead>
          <tr>
            <th>#</th>
            <th>Name</th>
            <th>Fuel Type</th>
            <th>Seating Capacity</th>
            {/* <th>Price</th> */}
            <th>Stock</th>
            <th>Packages</th>
            <th className="text-center">Actions</th>
          </tr>
        </thead>
        <tbody>
          {vehicles.map((vehicle, index) => (
            <tr key={vehicle._id || `${vehicle.name}-${index}`}>
              <td>{index + 1}</td>
              <td>{vehicle.name || "-"}</td>
              <td>{vehicle.fuelType || "-"}</td>
              <td>{vehicle.specifications?.seatingCapacity || "-"}</td>
              {/* <td>{vehicle.price ?? "-"}</td> */}
              <td>
                <span>
                  {vehicle.stock ?? 0}
                </span>
              </td>
              <td>
                <Button 
                  variant="primary" 
                  size="sm"
                  onClick={() => handleViewPackages(vehicle._id, vehicle.name)}
                >
                  <FaEye />
                </Button>
              </td>
              <td className="text-center">
                <Dropdown>
                  <Dropdown.Toggle variant="link" className="p-0 text-decoration-none">
                    &#x2022;&#x2022;&#x2022;
                  </Dropdown.Toggle>
                  <Dropdown.Menu align="end">
                    <Dropdown.Item onClick={() => onEdit(vehicle._id)} disabled={!vehicle._id}>
                      Edit
                    </Dropdown.Item>
                    <Dropdown.Item
                      onClick={() => onDelete(vehicle)}
                      className="text-danger"
                      disabled={!vehicle._id || isDeleting}
                    >
                      Delete
                    </Dropdown.Item>
                  </Dropdown.Menu>
                </Dropdown>
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
};

export default VehiclesTable;
